import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { AdminAuthService } from "@/service/api/admin-auth";
import { VerifyRecoverPasswordCodeDto } from "@/service/dto/admin-auth";

const useVerifyRecoveryCode = () => {
  return useMutation({
    mutationFn: (data: VerifyRecoverPasswordCodeDto) => AdminAuthService.verifyRecoveryCode(data),
    onError: () => {
      toast.error("Código inválido ou expirado. Verifique e tente novamente.", { toastId: "verify_recovery_code_error" });
    },
  });
};

export default useVerifyRecoveryCode;
